import { FC } from 'react';
import ExportedImage from 'next-image-export-optimizer';
import ShopperManCircle from '../../../../../public/images/Shopper_Man_Circle.webp';
import { Button, Tooltip } from '../../../../libs/components/components';
import { AppRoute } from '../../../../libs/enums/enums';
import ArrowRightIcon from '../../../../../public/svg/arrow-right.svg';

const HelpForHealing: FC = () => {
  return (
    <section className="bg-[radial-gradient(51.63%_382.95%_at_29.77%_276.38%,#3873B4_0%,#16477E_47.5%,#002855_100%)] px-[37px] py-6">
      <div className="flex flex-col gap-y-3 lg:flex-row items-center justify-center gap-x-10">
        <ExportedImage
          src={ShopperManCircle}
          alt="Shopper Man Circle"
          priority={false}
          className="w-[216px] h-[265px]"
        />
        <div className="flex flex-col text-white">
          <h3 className="text-[30px] font-bold">Get Help for Healing</h3>
          <p className="text-[20px]">
            Get email updates, discussion guides, and more
          </p>
          <Tooltip className="mt-4 self-start" content="Get updates">
            <Button
              to={AppRoute.GET_UPDATES}
              variant="white"
              className="flex items-center gap-x-2 rounded-full overflow-hidden focus:outline-none focus-visible:ring-2 focus-visible:ring-white/80 focus-visible:ring-offset-2 focus-visible:ring-offset-transparent transform-gpu will-change-transform [backface-visibility:hidden] px-4 py-2"
              linkClassName="inline-flex w-auto items-center justify-center"
              aria-label="Get updates"
            >
              Get Updates{' '}
              <ArrowRightIcon
                className="w-4 h-3"
                aria-hidden="true"
                focusable="false"
              />
            </Button>
          </Tooltip>
        </div>
      </div>
    </section>
  );
};

export { HelpForHealing };
